import axios from 'axios';
import { toast } from "react-toastify";


const API = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});





///////////////////////
//
//      APP
//
////////////////////////


//some trouble with frontend part... how can i make so that the file is then sownloaded by the browser? i need to change sumthing here

export const download_app = async () => {
    try {
        const access = localStorage.getItem('access_token');
        toast.warning("Il download è in preparazione, si prega di attendere qualche secondo");

        const response = await API.get('download_app/', {
            headers: {
                Authorization: `Bearer ${access}`
            },
            responseType: 'blob'
        });

        // Create a download link
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'app_v1.apk');
        document.body.appendChild(link);
        link.click();

        // Clean up
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        return { success: true };
    } catch (error) {
        return manage_error(error, download_app);
    }
};

///////////////////////
//
//      LOGS
//
////////////////////////



export const get_logs = async () => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('logs/', {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, get_logs);
    }
};


///////////////////////
//
//      ROCKFALL
//
////////////////////////



export const get_rockfalls = async () => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('rockfalls/', {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, get_rockfalls);
    }
};



export const get_rockfall_by_id = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('rockfalls/'+id, {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>get_rockfall_by_id(id));
    }
};



export const update_rockfall = async (id, data) => {
    try {
        const access = localStorage.getItem('access_token');
        const response = await API.put(`rockfalls/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_rockfall(id, data));
    }
};


export const patch_rockfall = async (id, data) => {
    try {
        const access = localStorage.getItem('access_token');
        const response = await API.patch(`rockfalls/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>patch_rockfall(id, data));
    }
};



export const create_rockfall = async (data) => {
    try {
        const access = localStorage.getItem('access_token');
        const response = await API.post(`rockfalls/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>create_rockfall(data));
    }
};





export const delete_rockfall = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.delete(`rockfalls/`+id+'/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>delete_rockfall(id));
    }
};









///////////////////////
//
//      TAG
//
////////////////////////





export const update_tag = async (id, data) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.put(`tags/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_tag(id, data));
    }
};



export const create_tag = async (data) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.post(`tags/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>create_tag(data));
    }
};





export const delete_tag = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.delete(`tags/`+id+'/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>delete_tag(id));
    }
};









export const get_tags_by_rockfall = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('tags_by_rockfall?rockfall='+id, {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>get_tags_by_rockfall(id));
    }
};









///////////////////////
//
//      IMAGES BY MAINTENANCE
//
////////////////////////



export const get_images_by_maintenance = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('images_by_maintenance?maintenance='+id, {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>get_images_by_maintenance(id));
    }
};





///////////////////////
//
//      DOCUMENTS BY MAINTENANCE
//
////////////////////////





export const get_documents_by_maintenance = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('documents_by_maintenance?maintenance='+id, {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>get_documents_by_maintenance(id));
    }
};







///////////////////////
//
//      INTERVENTIONS   a.k.a. MAINTENANCE
//
////////////////////////





export const update_intervention = async (id, data) => {
    try {
    console.log("UPDATING MAINTENANCE");
    console.log(id);
    console.log(data);

        const access = localStorage.getItem('access_token');
        data = format_all_dates_in_object(data);

        const response = await API.put(`maintenances/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_intervention(id, data));
    }
};



export const create_intervention = async (data) => {
    try {
        const access = localStorage.getItem('access_token');
        data = format_all_dates_in_object(data);

        const response = await API.post(`maintenances/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>create_intervention(data));
    }
};





export const delete_intervention = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.delete(`maintenances/`+id+'/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>delete_intervention(id));
    }
};








export const get_interventions_by_rockfall = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('maintenances_by_rockfall?rockfall='+id, {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>get_interventions_by_rockfall(id));
    }
};











///////////////////////
//
//      DOCUMENT
//
////////////////////////





export const update_document = async (id, data) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.put(`documents/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_document(id, data));
    }
};



export const create_document = async (data) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.post(`documents/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`,
                'Content-Type': 'multipart/form-data' // 👈 key part for Django to recognize file upload
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>create_document(data));
    }
};





export const delete_document = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.delete(`documents/`+id+'/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>delete_document(id));
    }
};








export const get_documents_by_rockfall = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('documents_by_rockfall?rockfall='+id, {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>get_documents_by_rockfall(id));
    }
};
























export const update_installationdocument = async (id, orig_data) => {
    try {
        const access = localStorage.getItem('access_token');

        console.log(orig_data);
        var data =  { ...orig_data };
        delete data["document"]; //if we send the file URL the API complains, so wtf just remove before sending

        const response = await API.patch(`installationdocuments/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_installationdocument(id, orig_data));
    }
};



export const create_installationdocument = async (data) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.post(`installationdocuments/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`,
                'Content-Type': 'multipart/form-data' // 👈 key part for Django to recognize file upload
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>create_installationdocument(data));
    }
};





export const delete_installationdocument = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.delete(`installationdocuments/`+id+'/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>delete_installationdocument(id));
    }
};














export const get_installation_documents_by_rockfall = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('installation_documents_by_rockfall?rockfall='+id, {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>get_installation_documents_by_rockfall(id));
    }
};






///////////////////////
//
//      DOCUMENT
//
////////////////////////




export const update_maintenance_document = async (id, data) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.put(`maintenance_documents/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_maintenance_document(id, data));
    }
};


export const create_maintenance_document = async (data) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.post(`maintenance_documents/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`,
                'Content-Type': 'multipart/form-data' // 👈 key part for Django to recognize file upload
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>create_maintenance_document(data));
    }
};





export const delete_maintenance_document = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.delete(`maintenance_documents/`+id+'/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>delete_maintenance_document(id));
    }
};








///////////////////////
//
//      USERS
//
////////////////////////




export const get_users = async () => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('users/', {
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, get_users);
    }
};








export const update_user = async (id, data) => {
    try {
        const access = localStorage.getItem('access_token');
        if(data.password === '') delete data.password;
        if(data.password_confirmation === '') delete data.password_confirmation;
        const response = await API.patch(`users/${id}/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>update_user(id, data));
    }
};



export const create_user = async (data) => {
    try {
        const access = localStorage.getItem('access_token');
        const response = await API.post(`users/`, data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`,
                'Content-Type': 'multipart/form-data' // 👈 key part for Django to recognize file upload
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>create_user(data));
    }
};





export const delete_user = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.delete(`users/`+id+'/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>delete_user(id));
    }
};




export const get_user_notifications = async () => {
    try {
        const access = localStorage.getItem('access_token');

        const response = await API.get('user_notifications/', {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>get_user_notifications());
    }
};




export const mark_notification_as_read = async (id) => {
    try {
        const access = localStorage.getItem('access_token');

        const data = {"id": id}

        const response = await API.post('user_notifications/', data, {  // <-- data is added here
            headers: {
                Authorization: `Bearer ${access}`
            }
        });

        return { success: true, data: response.data };
    } catch (error) {
        return manage_error(error, ()=>mark_notification_as_read(id));
    }
};






///////////////////////
//
//      LOGIN AND SUCH
//
////////////////////////









export const manage_call_result = (res) => {
  if(res && res.success===false){
    if(typeof(res.error)==='string'){
          debugger;

      toast.error("Errore imprevisto, si prega di riprovare.");
      return false;
    }
    var errs = Object.entries(res.error);
    var message = "";
    errs.forEach((e)=>{
      if(e && e[0] && e[1]){
        message = e[0]+": "+e[1];
        toast.error(message);
      }
    });
    return false;
  }
  return true;
}




export const manage_error = async (error, callback) => {

  if(error.status && error.status === 401){
    await refreshToken();
  }
  else{
    if(error){
      return { success: false, error: error.response ? error.response.data : error.message };
    }
  }

  try {
      var response = await callback();
      return { success: true, data: response.data };
  } catch (error) {
      return { success: false, error: error.response ? error.response.data : error.message };
  }

}





const convertDateFormat = (dateStr) => {
  // Split the input string by "/"
  console.log("DATE BEFORE: ");
  console.log(dateStr);
  const [day, month, year] = dateStr.split("/");
  // Return in yyyy-mm-dd format
  const new_str =  `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  console.log("DATE AFTER: ");
  console.log(new_str);
  return new_str
}


const format_all_dates_in_object = (obj) => {
  console.log("CONVERTING DATES NOOOOWWW");
  const newObj = { ...obj }; // Make a shallow copy to avoid mutating the original
  for (const key in newObj) {
    if (
      key.toLowerCase().includes("date") &&
      typeof newObj[key] === "string" &&
      /^\d{2}\/\d{2}\/\d{4}$/.test(newObj[key])
    ) {
      newObj[key] = convertDateFormat(newObj[key]);
    }
    else if (
      key.toLowerCase().includes("date") &&
      typeof newObj[key] === "object"
    ) {
      const the_date = newObj[key];

      if(!newObj[key]){
        newObj[key] = null;
      }
      else{
        const yyyy = the_date.getFullYear();
        const mm = String(the_date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const dd = String(the_date.getDate()).padStart(2, '0');
        const formattedDate = `${yyyy}-${mm}-${dd}`;
        newObj[key] = formattedDate;
      }


    }
  }
  return newObj;
}






// Function to login and get tokens
export const login = async (email, password) => {
    try {
        const response = await API.post('token/', { email, password });
        const { access, refresh } = response.data;



        localStorage.setItem('access_token', access);
        localStorage.setItem('refresh_token', refresh);

        const response_userinfo = await API.get('user_info/?email='+email, {headers: {
                Authorization: `Bearer ${access}`
          }
        });

        if(response_userinfo && response_userinfo.data){
            localStorage.setItem('first_name', response_userinfo.data.first_name);
            localStorage.setItem('last_name', response_userinfo.data.last_name);
            localStorage.setItem('role', response_userinfo.data.role);
            localStorage.setItem('user_id', response_userinfo.data.id);
            return { success: true };
        }
        else{
            return { success: false, error: "could not retrieve user data" };
        }

    } catch (error) {
        return { success: false, error: error.response?.data };
    }
};

// Function to refresh token
export const refreshToken = async () => {
    try {
        const refresh = localStorage.getItem('refresh_token');
        if (!refresh) throw new Error("No refresh token found");

        const response = await API.post('token/refresh/', { refresh });
        localStorage.setItem('access_token', response.data.access);

        return response.data.access;
    } catch (error) {
        console.error(error);
        debugger;
        logout();
        return null;
    }
};

// Function to verify token
export const verifyToken = async () => {

    const access = localStorage.getItem('access_token');
    if (!access) return false;

    try {
        await API.post('token/verify/', { token: access });
        return true;
    } catch {
        return false;
    }
};










// Function to log out
export const logout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.location.href = 'login'; // Refresh page to clear state
};



export default API;
